module.exports = __webpack_public_path__ + "static/media/lotus-flower.4b207eda.svg";